export const navigationShortcuts = [
  {
    key: "keyboardShortcutBack",
    value: "Alt+Backspace",
    label: "بازگشت ",
    route: "",
  },
  {
    key: "keyboardShortcutToggleSidebar",
    value: "Alt+Enter",
    label: "باز/بستن منو ",
    route: "",
  },
  {
    key: "keyboardShortcutNotificationsSidebar",
    value: "Alt+Z",
    label: "منو اعلانات",
    route: "",
  },
  {
    key: "keyboardShortcutDashboard",
    value: "Alt+D",
    label: "داشبورد",
    route: "/dashboard",
  },
  {
    key: "keyboardShortcutNewPerson",
    value: "Alt+Shift+C",
    label: "افزودن شخص",
    route: "/persons/add",
  },
  {
    key: "keyboardShortcutPersons",
    value: "Alt+C",
    label: "لیست اشخاص",
    route: "/persons",
  },
  {
    key: "keyboardShortcutNewProduct",
    value: "Alt+Shift+P",
    label: "افزودن محصول",
    route: "/products/add",
  },
  {
    key: "keyboardShortcutNewBank",
    value: "Alt+Shift+B",
    label: "افزودن حساب",
    route: "/financials/add",
  },
  {
    key: "keyboardShortcutProducts",
    value: "Alt+P",
    label: "لیست محصولات",
    route: "/products",
  },
  {
    key: "keyboardShortcutWarehouses",
    value: "Alt+W",
    label: "لیست انبار ها",
    route: "/inventories",
  },
  {
    key: "keyboardShortcutWareHouse",
    value: "Alt+Shift+W",
    label: "افزودن انبار",
    route: "/inventories/add",
  },
  {
    key: "keyboardShortcutBanks",
    value: "Alt+B",
    label: "لیست حساب ها",
    route: "/financials",
  },
  {
    key: "keyboardShortcutFactor",
    value: "Alt+Shift+F",
    label: "افزودن فاکتور",
    route: "/factors/add",
  },
  {
    key: "keyboardShortcutFactors",
    value: "Alt+F",
    label: "لیست فاکتور ها",
    route: "/factors",
  },
  {
    key: "keyboardShortcutTransaction",
    value: "Alt+Shift+T",
    label: "افزودن تراکنش",
    route: "/transactions/add",
  },
  {
    key: "keyboardShortcutTransactions",
    value: "Alt+T",
    label: "لیست تراکنش ها",
    route: "/transactions",
  },
  {
    key: "keyboardShortcutBill",
    value: "Alt+Shift+H",
    label: "افزودن حواله",
    route: "/remittance/add",
  },
  {
    key: "keyboardShortcutBills",
    value: "Alt+H",
    label: "لیست حواله ها",
    route: "/remittance",
  },
  {
    key: "keyboardShortcutReceivedCheque",
    value: "Alt+Shift+K",
    label: "لیست چک های پرداختی",
    route: "/cheques/payment",
  },
  {
    key: "keyboardShortcutReceivedCheques",
    value: "Alt+K",
    label: "لیست چک های دریافتی",
    route: "/cheques/receive",
  },
  {
    key: "keyboardShortcutAccounting",
    value: "Alt+Shift+N",
    label: "افزودن سند حسابداری",
    route: "/accounting/add",
  },
  {
    key: "keyboardShortcutAccountings",
    value: "Alt+N",
    label: "لیست اسناد حسابداری",
    route: "/accounting",
  },
  {
    key: "keyboardShortcutWarehouseSupply",
    value: "Alt+M",
    label: "موجودی انبار",
    route: "/inventories/supply",
  },
  {
    key: "keyboardShortcutReports",
    value: "Alt+G",
    label: "گزارشات",
    route: "/reports",
  },
  {
    key: "keyboardShortcutSettings",
    value: "Alt+Q",
    label: "تنظیمات",
    route: "/settings",
  },
  {
    key: "keyboardShortcutExtend",
    value: "Alt+X",
    label: "تمدید اشتراک",
    route: "/business/extend",
  },
  {
    key: "keyboardShortcutAppReset",
    value: "ctrl+Shift+R",
    label: "بازنشانی / بروزرسانی نرم افزار",
  },
];
export const formShortcuts = [
  {
    key: "keyboardShortcutNewForm",
    valueShow: "Alt+✛",
    value: "Alt+NumpadAdd",
    label: "افزودن فرم",
  },
  {
    key: "keyboardShortcutResetForm",
    value: "Alt+Shift+R",
    label: "بازنشانی فرم",
  },
  {
    key: "keyboardShortcutPrevForm",
    valueShow: "Alt+↑",
    value: "Alt+ArrowUp",
    label: "فرم قبلی",
  },
  {
    key: "keyboardShortcutNextForm",
    valueShow: "Alt+↓",
    value: "Alt+ArrowDown",
    label: "فرم بعدی",
  },
  {
    key: "keyboardShortcutSaveForm",
    value: "Alt+S",
    label: "ذخیره فرم",
  },
  // {
  //   key: "keyboardShortcutSaveDraft",
  //   value: "Alt+Shift+s",
  //   label: "ذخیره پیش نویس",
  // },
];
export const tableShortcuts = [
  {
    key: "keyboardShortcutFirstPage",
    valueShow: "Alt+↑",
    value: "Alt+ArrowUp",
    label: "صفحه ی اول",
  },
  {
    key: "keyboardShortcutLastPage",
    valueShow: "Alt+↓",
    value: "Alt+ArrowDown",
    label: "صفحه ی آخر",
  },
  {
    key: "keyboardShortcutNextPage",
    valueShow: "Alt+←",
    value: "Alt+ArrowLeft",
    label: "صفحه ی بعدی",
  },
  {
    key: "keyboardShortcutPreviousPage",
    valueShow: "Alt+→",
    value: "Alt+ArrowRight",
    label: "صفحه ی قبلی",
  },
  {
    key: "keyboardShortcutSelectAll",
    value: "Alt+A",
    label: "انتخاب همه",
  },
  {
    key: "keyboardShortcutDownloadExcel",
    value: "Alt+E",
    label: "دانلود اطلاعات جدول در قالب اکسل",
  },
  {
    key: "keyboardShortcutDownloadPdf",
    value: "Alt+Shift+E",
    label: "دانلود اطلاعات جدول در قالب پی دی اف",
  },
  {
    key: "keyboardShortcutResetSearch",
    value: "Alt+R",
    label: "باز نشانی جستجو",
  },
  // {
  //   key: "keyboardShortcutView",
  //   value: "Enter",
  //   label: "مشاهده سند",
  // },
  // {
  //   key: "keyboardShortcutDelete",
  //   value: "delete",
  //   label: "حذف سند",
  // },
];
